import { render, staticRenderFns } from "./ModalContract.vue?vue&type=template&id=742edaa4&"
import script from "./ModalContract.vue?vue&type=script&lang=js&"
export * from "./ModalContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports